import React, { Fragment, useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';

import mixpanel from 'mixpanel-browser';

// Firebase
import { db } from '../../config/firebase-config';
import { collection, getDocs, getDoc, addDoc, updateDoc, doc, setDoc, deleteDoc, query, where, onSnapshot, orderBy, startAfter, limit } from 'firebase/firestore';

// ALGOLIA SEARCH
import algoliasearch from 'algoliasearch/lite';

// Redux
import { connect } from 'react-redux';

// Actions
import { setSearchPosts, set_NoMoreProducts, set_LastPageDoc, set_ShowBottomSpinner, set_NoMorePosts, setSearchPosts_WithImgs } from '../../actions/postActions';
import { toggleSideNav, setPage, add_To_Recent_History } from '../../actions/navActions';
import { setAlert } from '../../actions/alertActions';
import { getPopularSearches } from '../../actions/searchActions';
import { setGroups } from '../../actions/groupActions';

// Layout Wrapper
import SearchLayout from '../../components/layout/SearchLayout';

// components
import Spinner from '../../components/common/Spinner';
import TweetBox from '../../components/TweetBox/TweetBox';
import Post from '../../components/Post/Post';
import GettingStarted from '../../components/common/GettingStarted';
import HowItWorks from '../../components/common/HowItWorks';
import Image_Block from '../MediaPage/Image_Block';
import DefaultAvatar from 'react-avatar';
import { Avatar, Button } from '@material-ui/core';
import Empty_Card from '../MediaPage/Empty_Card';
import GroupBlock from '../../components/Groups/GroupBlock';

// Icons
import PostAddIcon from '@material-ui/icons/PostAdd';
import AddIcon from '@material-ui/icons/Add';
import SearchIcon from '@material-ui/icons/Search';
import CloseIcon from '@material-ui/icons/Close';
import SignalCellularAltOutlinedIcon from '@material-ui/icons/SignalCellularAltOutlined';
import VerifiedUserIcon from '@material-ui/icons/VerifiedUser';
import LocalMallOutlinedIcon from '@material-ui/icons/LocalMallOutlined';

// Images
import no_search_results_image from '../../utils/imgs/no_search_results_image.png';
import searchPage_placeholder_img from '../../utils/imgs/searchPage_placeholder_img.png';
import SportsSection from '../../components/Sports/SportsSection';
import { HorizontalNav } from '../../components/common/HorizontalNav';
import replaceHyphenWithSpace from '../../utils/reusable_functions/replace_Hyphens_With_Space';
import { CATEGORY_LIST } from '../../utils/constant_variables/CATEGORIES_LIST';
import FILTER_OPTIONS from '../../utils/constant_variables/FILTER_OPTIONS';

const MAX_POPULAR_SEARCHES_COUNT = 3;
const MAX_CATEGORIES_COUNT = 5;

const SearchPage = ({ 
    setSearchPosts,
    setSearchPosts_WithImgs,
    toggleSideNav, 
    setPage, 
    add_To_Recent_History,
    setAlert, 
    getPopularSearches,
    setGroups,
    set_ShowBottomSpinner,
    set_LastPageDoc,
    set_NoMorePosts,
    auth, 
    post: {
        posts,
        no_more_posts,
        show_bottom_spinner,
        last_page_doc,
        loading
    },
    nav: { 
        sideNav,
        website,
        website_loading,
    }, 
    search: {
        popular_searches,
        popular_loading,
    },
    group
}) => {

    // Analytics 
    const [sentMixpanel, setSentMixpanel] = useState(false);

    // Window width
    const [windowWidth, setWindowWidth] = useState(window.innerWidth);

    // Check if user is verified
    const [checkedVerification, setCheckedVerification] = useState(false);

    // Posts
    const [postList, setPostList] = useState([]);
    const [gotPosts, setGotPosts] = useState(false);

    // Groups
    const [groupsList, setGroupsList] = useState([]);
    const [gotGroups, setGotGroups] = useState(false);

    // Scroll direction - for displaying top nav bar
    const [scrollDirection, setScrollDirection] = useState("up");
    const [oldScrollY, setOldScrollY] = useState(window.scrollY);

    // Temporarily disable to load more function to avoid duplicate fetch requests
    const [canLoadMore, setCanLoadMore] = useState(true);

    // Get the current URL and extract the "filter" parameter
    const url_filter = (window.location.href);
    const url = new URL(url_filter);
    const filter = url.searchParams.get("q");
    const display_filter = url.searchParams.get("show");
    const intent_filter = url.searchParams.get("intent");
    const hostname = window.location.hostname;

    const SPACE_HEIGHT = 250; // Hieght of className 'no-rides' which is a spacer to make sure user can always scroll down


    // Firebase collection ref
    const postsCollectionRef = collection(db, "posts");

    // Algolia search
    const searchClient = algoliasearch('H8YQ3RB3ZI', 'b797e6858550b93ae143de5b4941f4e9'); // change the secret key (2nd) to specific api key
    const searchIndex = searchClient.initIndex('posts_date_desc');
    const groupIndex = searchClient.initIndex('campuses');

    // Determine window size breakpoints
    const isMobile = windowWidth <= 769;
    const isTablet = windowWidth <= 1000;
    
    useEffect(() => {
        setPage('search');
        add_To_Recent_History(url.pathname);  // current url
        getPopularSearches({page_size: 4});

    }, []);

    // Listen for window resize event and update window width state
    useEffect(() => {

        // Add event listener for window resize
        window.addEventListener('resize', () => handleWindowSizeChange());

        // Clean up by removing event listener on component unmount
        return () => window.removeEventListener('resize', () => handleWindowSizeChange());
    }, []);

    useEffect(() => {

        if(display_filter !== 'groups') {
            renderPostList();
        }

    }, [posts, loading, canLoadMore]);

    useEffect(() => {

        if(display_filter === 'groups') {
            renderGroupsList();
        }

    }, [group.groups, group.loading, canLoadMore]);

    // Update window width state on window resize
    const handleWindowSizeChange = () => {
        setWindowWidth(window.innerWidth);
    };

    // Infinite scroll AND handle top nav bar display
    const handleScroll = (e) => {
        const { offsetHeight, scrollTop, scrollHeight} = e.target

        const newScrollY = offsetHeight + scrollTop;

        // --- Handle top nav bar display
        if(isMobile) {
            if(oldScrollY < newScrollY){

                // scrolling down - hide top nav
                setScrollDirection("down");
    
                if(document.getElementById('feed-header') !== null) {
                    document.getElementById('feed-header').classList.remove("active");
                }
                
            } else {
    
                // scrolling up - show top nav
                setScrollDirection("up");
    
                if(document.getElementById('feed-header') !== null) {
                    document.getElementById('feed-header').classList.add("active");
                }
            }
        }
        // --- END Handle top nav bar display

        // update the scroll position for future comparison
        setOldScrollY(newScrollY)

        // Check if the user has scrolled to the bottom of the content and conditions for loading more posts are met
        if (newScrollY >= scrollHeight - (SPACE_HEIGHT+1) && !show_bottom_spinner && !no_more_posts && filter !== null && popular_searches.length > 0 && (posts.length > 0 || group.groups.length > 0) && canLoadMore) {
            console.log('scrolling');
            loadMore(last_page_doc);
        }
    }

    // Function to load more paginated posts
    const loadMore = async (lastPage_doc) => {

        try {
            // console.log("last", lastPage_doc);

            let temp_intent_filter;
            if(intent_filter) {
                temp_intent_filter = replaceHyphenWithSpace(intent_filter);
            }

            // Temporarily disable to load more function to avoid duplicate fetch requests
            setCanLoadMore(false);

            // Show spinner
            set_ShowBottomSpinner(true);

            let results = [];

            if(display_filter === 'groups') {
                results = await groupIndex.search(filter, {
                    filters: `can_discover:true`,
                    page: lastPage_doc,
                    hitsPerPage: 10
                });
            } else if(display_filter === 'media') {
                if(website) {
                    results = await searchIndex.search(filter, {
                        filters: `group._id:${website._id} AND img_count > 0`,
                        page: lastPage_doc,
                        hitsPerPage: 10
                    });
                } else {
                    results = await searchIndex.search(filter, {
                        filters: `group_is_private:false AND img_count > 0`,
                        page: lastPage_doc,
                        hitsPerPage: 10
                    });
                }
            } else {
                let searchFilters = null;

                if(website) {
                    searchFilters = `group._id:${website._id}${temp_intent_filter ? ` AND \"filter_tags.${temp_intent_filter}\":true` : ''}`;
                } else {
                    searchFilters = `group_is_private:false${temp_intent_filter ? ` AND \"filter_tags.${temp_intent_filter}\":true` : ''}`;
                }

                results = await searchIndex.search(filter, {
                    filters: searchFilters,
                    page: lastPage_doc,
                    hitsPerPage: 10
                });
            }

            console.log('SEARCH RESULT');
            // console.log(results);

            // setPosts(results.hits.map((doc) => ({...doc, _id: doc.objectID})));

            // Fetch initial posts
        
            console.log('UPDATING RESULTS...');
            const tempResultList = results.hits.map((doc) => ({...doc, _id: doc.objectID}));

            if(tempResultList.length < 2) {
                set_NoMorePosts(true);
            }

            // if loading posts
            if(!display_filter || display_filter === 'posts') {
                // Recursively fetch comments of comments
                const fetchCommentsOfComments = async (comments) => {
                    for (let i = 0; i < comments.length; i++) {
                        const comment = comments[i];
                        
                        // Create a query to retrieve comments where the post_commented_on field matches the comment ID, ordered by creation date in descending order
                        const commentOfCommentQuery = query(postsCollectionRef, where("post_commented_on", "==", comment._id), orderBy('createdAt', 'asc'));
                        
                        // Execute the query and retrieve the query snapshot
                        const commentOfCommentSnapshot = await getDocs(commentOfCommentQuery);
                        
                        // Map through the document snapshots in the query snapshot and extract the data and ID for each comment of comment
                        const commentsOfComments = commentOfCommentSnapshot.docs.map((doc) => ({...doc.data(), _id: doc.id}));
                        
                        // Append the comments of comments to the current comment
                        comment.commentsOfComments = commentsOfComments;
                        
                        // Recursively fetch comments of comments for the current comment
                        await fetchCommentsOfComments(commentsOfComments);
                    }
                };
                
                // Fetch comments of comments for the initial set of comments
                await fetchCommentsOfComments(tempResultList);
            }

            if(display_filter === 'media') {
                await setSearchPosts_WithImgs(tempResultList);
            } else if(display_filter === 'groups') {
                setGroups(tempResultList);
            } else {
                setSearchPosts(tempResultList);
            }

            // Get the last visible document for the next load
            set_LastPageDoc(lastPage_doc + 1);
    
            // Hide the loading spinner
            set_ShowBottomSpinner(false);


        } catch (error) {
            console.log('Error: Loading more search results')
            console.log(error);
        } finally {
            // Re-enable the load more function after 1 second
            setCanLoadMore(true);
        }
    }

    // END - Infinite Scroll

    const renderPostList = async () => {
        setPostList([]);

        if((posts === null && loading) || loading || !gotPosts) {
            setPostList([(
                <div className="no-rides">
                    <Spinner />
                </div>
            )])
        }
        else { 
            if(posts.length > 0) {
                posts.map(post_doc => {
                    if (display_filter === 'media') {
                        setPostList(postList => [...postList, (
                            <Image_Block key={post_doc._id} detailPost={post_doc} />
                        )])
                    } else {
    
                        const renderPostRecursive = (postComments, parentPost) => {
                            
                            const lastComment = postComments[postComments.length - 1]; // Get the last comment
    
                            return (
                                <Fragment>
                                    <Post key={lastComment._id} postDoc={lastComment} parentPost={parentPost} />
    
                                    {/* Recursive call to render comments of comments */}
                                    {lastComment.commentsOfComments && lastComment.commentsOfComments.length > 0 && (
                                        <div className="comments-of-comments">
                                        {renderPostRecursive(lastComment.commentsOfComments, lastComment)}
                                        </div>
                                    )}
                                </Fragment>
                            );
    
                        };
    
                        if(post_doc.commentsOfComments && post_doc.commentsOfComments.length > 0) {
                            setPostList(postList => [...postList, (
                                <div className='post_container'>
                                    <Post key={post_doc._id} postDoc={post_doc} />
    
                                    {renderPostRecursive(post_doc.commentsOfComments, post_doc)}
                                </div>
                            )])
                        } else {
                            setPostList(postList => [...postList, (
                                <Post key={post_doc._id} postDoc={post_doc} parentPost={post_doc.post_commented_on && true} />
                            )])
                        }
    
                    }
                }) 
            } else if(filter !== null) {
                // Display a message when there are no search posts
                setPostList(postList => [...postList, (
                    <div className="no-results" style={{marginTop:'80px', minHeight: '200px'}}>
                        <div className='search_imgContainer'>
                            <img style={{maxWidth:'55%'}} src={no_search_results_image} />
                        </div>
                        
                        <h1>No {display_filter === 'media' ? 'photos / videos' : 'results'} for <br/>"{filter}"</h1>
                        <h2>Try searching for something else</h2>
                    </div>
                )])
            } else {
                // Display a default message 
                setPostList(postList => [...postList, (
                    <div className="no-rides" style={{marginTop:'80px', minHeight: '200px'}}>
                        <h1>Start typing to search…</h1>
                        <img style={{maxWidth:'70%'}} src={searchPage_placeholder_img} />
                    </div>
                )])
            }
        } 

        setGotPosts(true);
    }

    // --- Search Groups ---

    const renderGroupsList = async () => {
        setGroupsList([]);

        if((group.groups === null && group.loading) || group.loading || !gotGroups) {
            setGroupsList([(
                <div className="no-rides">
                    <Spinner />
                </div>
            )])
        }
        else { 
            if(group.groups.length > 0) {
                group.groups.map(group_doc => {
                    setGroupsList(groupsList => [...groupsList, (
                        <GroupBlock key={group_doc._id} group_doc={group_doc} />
                    )])
                }) 
            } else if(filter !== null) {
                // Display a message when there are no search posts
                setGroupsList([(
                    <div className="no-results" style={{marginTop:'80px', minHeight: '200px'}}>
                        <div className='search_imgContainer'>
                            <img style={{maxWidth:'55%'}} src={no_search_results_image} />
                        </div>
                        
                        <h1>No results for <br/>"{filter}"</h1>
                        <h2>Try searching for something else</h2>
                    </div>
                )])
            } else {
                // Display a default message 
                setGroupsList([(
                    <div className="no-rides" style={{marginTop:'80px', minHeight: '200px'}}>
                        <h1>Start typing to search…</h1>
                        <img style={{maxWidth:'70%'}} src={searchPage_placeholder_img} />
                    </div>
                )])
            }
        } 

        setGotGroups(true);
    }

    // --- END: Search Groups ---

    let popularSearch_list;

    // Check if posts are null or not yet fetched
    if(popular_searches === null) {
        popularSearch_list = [<Spinner />];
    }
    else {
        if(popular_searches.length > 0) {

            // Iterate through the posts array and render each post component
            popularSearch_list = popular_searches.map(popular_search => {
                if(popular_search) {
                    return (
                        <div onClick={() => window.location = `/search?q=${popular_search.text}`} className="search-dropdown-item less_y_padding" key={popular_search._id}>
                            <div className='search_dropdown_item_icon'>
                                <SearchIcon />
                            </div>
                            <div className='search_dropdown_item_option'>
                                <div className='generated_result'>
                                    <span>
                                        
                                    </span>
                                    <span>
                                        {popular_search.text}
                                    </span>
                                </div>
                                <div className='search_stats'>
                                    {popular_search.total_views}
                                    <SignalCellularAltOutlinedIcon />
                                </div>
                            </div>
                        </div>
                    )
                }
            })
        } else {
            // Display a default message 
            popularSearch_list = [(
                <div className="no-rides" style={{marginTop:'80px', minHeight: '200px'}}>
                    <h1>Start typing to search…</h1>
                    <img style={{maxWidth:'70%'}} src={searchPage_placeholder_img} />
                </div>
            )];
        }
    }


    // Function to handle Mixpanel analytics
    const handleMixpanel = () => {
        mixpanel.init(process.env.REACT_APP_MIXPANEL_ID);
        mixpanel.track("Search Page View");
    }

    // Trigger Mixpanel analytics on initial render in production mode
    if(process.env.NODE_ENV === 'production' && !sentMixpanel && !hostname.includes('xbuysell')) {
        handleMixpanel();
        setSentMixpanel(true);
    }

    // Check if user's school email is verified. If no redirect to school email page
    if(auth.user && !auth.user.verified && !checkedVerification) {
        window.location.href = '/verify';

        setCheckedVerification(true);
    }

    return (
        <Fragment>
            <SearchLayout lastPageDoc={last_page_doc} setLastPageDoc={set_LastPageDoc} popularSearch_list={popularSearch_list} popular_searches={popular_searches} handleScroll={handleScroll} sideNav={sideNav} handleSlideMenu={toggleSideNav} page="home">

                {/* Render AddIcon for creating a post on tablet devices */}
                {/* {!auth.loading && auth.user ? (
                    isTablet && (
                        <Link to={`/create/post?goBack=${page}`} id="fixed-button" className="show">
                            <AddIcon />
                        </Link>
                    )
                ) : null} */}

                {filter !== null && (
                    <div className="feed_headerTabs">
                        <div className={`${(display_filter === null || display_filter === undefined || display_filter === 'latest') && 'active'}`} onClick={() => window.location = `${window.location.pathname}?q=${filter}`}>
                            <h3>Latest</h3>
                            <div className="block__underline"></div>
                        </div>
                        <div className={`${(display_filter && display_filter === 'media') && 'active'}`} onClick={() => window.location = `${window.location.pathname}?q=${filter}&show=media`}>
                            <h3>Photos</h3>
                            <div className="block__underline"></div>
                        </div>
                        {(!website_loading && !website) && (
                            <Fragment>
                                <div className={`${(display_filter && display_filter === 'groups') && 'active'}`} onClick={() => window.location = `${window.location.pathname}?q=${filter}&show=groups`}>
                                    <h3>Groups</h3>
                                    <div className="block__underline"></div>
                                </div>
                            </Fragment>
                        )}
                    </div>
                )}
                
                
                {/* Render the postList */}
                {filter !== null && popular_searches.length > 0 ? (
                    <Fragment>
                        {/* Render media */}
                        {display_filter === 'media' && posts?.length > 0 && (
                            <div style={{width: '100%', height: 'fit-content', display: 'grid', gridTemplateColumns: 'repeat(3, 1fr)', gridAutoRows: 'min-content', borderBottom: '1px solid #ddd'}}>
                                
                                {postList}

                                {(!no_more_posts && posts.length !== 0) && (<Empty_Card last_page_doc={last_page_doc} page={"gallery"} loadMore={loadMore} setCanLoadMore={setCanLoadMore} canLoadMore={canLoadMore} />)}
                            </div>
                        )}
                        
                        {/* Render groups */}
                        {display_filter === 'groups' && groupsList}

                        {/* Render posts */}
                        {(display_filter !== 'media' && display_filter !== 'groups') && (
                            <Fragment>
                                {/* Filter Options */}
                                {!intent_filter && !(posts?.length > 0) ? null : (
                                    <div style={{margin: '13px 0 3px'}}>
                                        <HorizontalNav>
                                            {intent_filter && (
                                                <div
                                                    onClick={() => {
                                                        // Create a copy of the current url object
                                                        const current_url = new URL(url_filter);
                                                        // remove any url variables 
                                                        current_url.searchParams.delete('intent');
                                                        // reload page
                                                        window.location.href = current_url.href;
                                                    }}
                                                    style={{
                                                        // display: 'inline-block',
                                                        // alignSelf: 'stretch',
                                                        display: 'flex',
                                                        alignItems: 'center',
                                                        justifyContent: 'center',
                                                        height: '33px',
                                                        minWidth: '33px',
                                                        borderRadius: '9999px',
                                                        backgroundColor: '#f3f4f6',
                                                        color: '#4b5563',
                                                        transition: 'background-color 0.15s ease-in-out',
                                                        cursor: 'pointer',
                                                        marginLeft: '5px',
                                                        marginRight: '5px'
                                                    }}
                                                    className='icon_20'
                                                >
                                                    <CloseIcon />
                                                </div>
                                            )}
                                            {FILTER_OPTIONS.map(item => {
                                                const isActive = item._id === intent_filter;
                                                return (
                                                    <div
                                                        onClick={() => {
                                                            // Create a copy of the current url object
                                                            const current_url = new URL(url_filter);
                                                            if(!isActive) {
                                                                // add this filter's ID to the url variables (automatically handles ? or & formatting)
                                                                current_url.searchParams.set('intent', item._id?.trim());
                                                            } else {
                                                                // add this filter's ID to the url variables (automatically handles ? or & formatting)
                                                                current_url.searchParams.delete('intent');
                                                            }
                                                            // reload page
                                                            window.location.href = current_url.href;
                                                        }}
                                                        style={{
                                                            display: 'flex',
                                                            alignItems: 'center',
                                                            justifyContent: 'center',
                                                            padding: '0 16px',
                                                            boxSizing: 'border-box',
                                                            height: '33px',
                                                            minWidth: 'fit-content',
                                                            borderRadius: '9999px',
                                                            backgroundColor: isActive ? '#3b82f6' : '#f3f4f6',
                                                            color: isActive ? '#ffffff' : '#4b5563',
                                                            fontSize: '14px',
                                                            fontWeight: 600,
                                                            fontFamily: 'sans-serif',
                                                            transition: 'background-color 0.15s ease-in-out',
                                                            cursor: 'pointer',
                                                            marginLeft: '5px'
                                                        }}
                                                    >
                                                        {item.name}
                                                    </div>
                                                )
                                            })}
                                            
                                        </HorizontalNav>
                                    </div>
                                )}
                                {postList}
                            </Fragment>
                        )}
                        
                        {/* Render empty list for media */}
                        {(display_filter === 'media' && !(posts?.length > 0)) && postList}

                        {/* Add space to the bottom of the page b/c of auth alert  */}
                        <div style={{height: '200px'}}></div>
                    </Fragment>
                ) : (
                    <Fragment>
                        <div style={{margin: '13px 0 5px'}}>
                            <HorizontalNav>
                                {CATEGORY_LIST.map(item => {
                                    if(item.parent_id !== null) return;
                                    return (
                                        <div
                                            onClick={() => {
                                                window.location.href = `/category/${item.url_handle}`;
                                            }}
                                            style={{
                                                display: 'flex',
                                                alignItems: 'center',
                                                justifyContent: 'center',
                                                padding: '0 16px',
                                                boxSizing: 'border-box',
                                                height: '33px',
                                                minWidth: 'fit-content',
                                                borderRadius: '9999px',
                                                backgroundColor: '#f3f4f6',
                                                color: '#4b5563',
                                                fontSize: '14px',
                                                fontWeight: 600,
                                                fontFamily: 'sans-serif',
                                                transition: 'background-color 0.15s ease-in-out',
                                                cursor: 'pointer',
                                                marginLeft: '5px'
                                            }}
                                        >
                                            {item.name}
                                        </div>
                                    )
                                })}
                                
                            </HorizontalNav>
                        </div>
                        
                        {popular_searches.length > 0 && (
                            <div style={{borderBottom: '1px solid #e6ecf0'}}>
                                {popular_searches.length > 0 && (
                                    <div className='menu-title' style={{display: 'flex', justifyContent:'space-between', alignItems: 'center', padding: '12px 16px'}}>
                                        <div style={{lineHeight:'24px', fontSize:'20px', fontWeight:700, wordWrap:'break-word', overflow:'hidden', textOverflow:'ellipsis', whiteSpace:'nowrap'}}>
                                            <span>Popular searches</span>
                                        </div>
                                    </div>
                                )}

                                {popularSearch_list?.slice(0, MAX_POPULAR_SEARCHES_COUNT) || []}

                                {/* See more btn */}
                                {(popularSearch_list.length > 0 && !(popularSearch_list.length < MAX_POPULAR_SEARCHES_COUNT)) && (

                                    <div style={{width: '100%', padding: '16px', boxSizing: 'border-box'}}>
                                        <div onClick={() => window.location = `/popular-searches`} className='see_more_btn full_width'>
                                            See more popular searches
                                        </div>
                                    </div>
                                )}
                            </div>
                        )}

                        <SportsSection sport_type="football" />
                
                        <div style={{borderBottom: '1px solid #e6ecf0'}}>
                            <div className='menu-title' style={{display: 'flex', justifyContent:'space-between', alignItems: 'center', padding: '12px 16px'}}>
                                <div style={{lineHeight:'24px', fontSize:'20px', fontWeight:700, wordWrap:'break-word', overflow:'hidden', textOverflow:'ellipsis', whiteSpace:'nowrap'}}>
                                    <span>Categories</span>
                                </div>
                            </div>
                            {CATEGORY_LIST.filter(item => item.parent_id === null).slice(0, MAX_CATEGORIES_COUNT).map(item => {
                                return (
                                    <div onClick={() => window.location.href = `/category/${item.url_handle}`} className={`notification`} style={{height: '100px'}}>
                                        <div className="categoryBlock_img">
                                            <img style={{height: '100%'}} src={item.img} />
                                        </div>

                                        <div className='categoryBlock_content'>
                                            <h1>{item.name}</h1>
                                            <div style={{height: '100%', display: 'flex', alignItems: 'center', paddingRight: '10px'}}>
                                                <div className='see_more_btn icon_18' style={{zIndex: 10}}>
                                                    {/* Icon */}
                                                    <LocalMallOutlinedIcon />
                                                    <span style={{width: '5px'}}></span>
                                                    Browse 
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                )
                            })}

                            {/* See more btn */}
                            {(CATEGORY_LIST.length > 0 && !(CATEGORY_LIST.length < MAX_CATEGORIES_COUNT)) && (

                            <div style={{width: '100%', padding: '16px', boxSizing: 'border-box'}}>
                                <div onClick={() => window.location = `/categories`} className='see_more_btn full_width'>
                                    See all categories
                                </div>
                            </div>
                            )}
                        </div>

                    </Fragment>
                )}

                {/* Render a spinner at the bottom if there are more posts to load */}
                {show_bottom_spinner && !no_more_posts && <Spinner />}
                {/* <button onClick={loadMore}>More Posts</button> */}
                
                {/* Display a message when there are no more posts */}
                <div className="no-rides">{(no_more_posts && posts.length !== 0) && "You've reached the end."}</div>
            </SearchLayout>
        </Fragment>
    )
}

SearchPage.propTypes = {
    setSearchPosts: PropTypes.func.isRequired,
    setSearchPosts_WithImgs: PropTypes.func.isRequired,
    toggleSideNav: PropTypes.func.isRequired,
    setPage: PropTypes.func.isRequired, // Function prop to set the current page in the navigation
    add_To_Recent_History: PropTypes.func.isRequired,
    setAlert: PropTypes.func.isRequired,
    getPopularSearches: PropTypes.func.isRequired,
    setGroups: PropTypes.func.isRequired,
    set_ShowBottomSpinner: PropTypes.func.isRequired,
    set_LastPageDoc: PropTypes.func.isRequired,
    set_NoMorePosts: PropTypes.func.isRequired,
    post: PropTypes.object.isRequired,
    nav: PropTypes.object.isRequired,
    auth: PropTypes.object.isRequired, // Object prop representing the authentication state of the user
    search: PropTypes.object.isRequired,
    group: PropTypes.object.isRequired
}

const mapStateToProps = state => ({

    // Mapping the states from the Redux store to the below props
    post: state.post,
    nav: state.nav,
    auth: state.auth,
    search: state.search,
    group: state.group
});

export default connect(mapStateToProps, { 

    // Connecting actions to the component
    setSearchPosts,
    setSearchPosts_WithImgs,
    toggleSideNav, 
    setPage, 
    add_To_Recent_History,
    setAlert,
    getPopularSearches,
    setGroups,
    set_ShowBottomSpinner,
    set_LastPageDoc,
    set_NoMorePosts,
})(SearchPage);
